<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :title="getVerbose('user_blocked_modal_title')"
        width="70%"
    >
        <div class="unblock-user-modal" v-if="dialogVisible">
            <ns-loader
                ref="nsLoader"
                :toLoad="dataToLoad"
                @dataFetched="onDataFetched"
            >
                <el-form
                    slot="content"
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-position="top"
                    label-width="150px"
                >
                    <el-form-item
                        :label="getVerbose('user_blocked_form_label_groups')"
                        prop="blockedUsers"
                    >

                        <el-transfer
                            ref="blockUserTransfert"
                            v-model="form.blockedUsers"
                            :filter-placeholder="getVerbose('user_blocked_filter_placeholder')"
                            :data="usersFormated"
                            :titles="[getVerbose('user_blocked_form_transfer_from'), getVerbose('user_blocked_form_transfer_to')]"
                            class="transfert-sized"
                            filterable
                        >
                        </el-transfer>
                    </el-form-item>
                </el-form>
            </ns-loader>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ getVerbose('user_modal_manage_user_roles_button_close') }}</el-button>
            <el-button
                type="primary"
                :loading="saving"
                @click="onUnblockUsers"
            >
                {{ getVerbose('user_modal_manage_user_roles_button_save') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import NsLoader from '../../partials/ns-vue-loader.vue';
import schwartz from 'schwartz';
export default {

    components: {
        NsLoader,
    },

    props: {

        getVerbose: {
            type: Function,
            required: true
        }
    },

    data (){
        let checkTransfertButtons = (rule, value, callback) => {
            let transfert = this.$refs.blockUserTransfert;
            if(transfert.leftChecked.length > 0 || transfert.rightChecked.length > 0 ){
                callback(new Error(this.getVerbose('user_groups_edit_validator_error')));
            }else{
                callback();
            }
        };
        return {
            saving: false,
            dialogVisible: false,
            blockedUsers: [],
            form:{
                blockedUsers: [],
            },
            rules: {
                blockedUsers: [
                    { validator: checkTransfertButtons, trigger: 'blur' }
                ]
            },
            dataToLoad: [{
                name: 'blockedUsers', model: 'unblockUsers',
            }]
        };
    },

    computed: {
        usersFormated (){
            return schwartz(this.blockedUsers.map((user) => {
                return {
                    label: user.email,
                    key: user.uid,
                };
            }), (user) => {user.email;});
        },

    },

    mounted (){

    },

    methods: {
        onDataFetched (res){
            if(res.blockedUsers) {
                this.$set(this, 'blockedUsers', res.blockedUsers);
            } else {
                this.$set(this, 'blockedUsers', []);
            }
        },
        open(){
            this.dialogVisible = true;
        },
        onUnblockUsers (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.saving = true;
                    this.$store.dispatch('unblockUsers', {user_uids: this.form.blockedUsers}).then(() => {
                        this.saving = false;
                        this.$emit('usersUnblocked');
                        this.$notify.success({
                            title: this.getVerbose('user_update_success_title'),
                            message: `${this.getVerbose('user_unblock_success_message')}`
                        });
                        this.dialogVisible = false;
                    }).catch((e) => {
                        this.$notify.error({
                            title: this.getVerbose('user_update_failure_title'),
                            message: `${this.getVerbose('user_unblock_failure_message')}`
                        });
                        this.saving = false;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/modal-unblock-user.vue